import { HomeTeacherTable } from './HomeTeacherTable';
export default HomeTeacherTable;
